import { Component, Input, OnInit, signal } from '@angular/core';
import { ClientFeatureSwitchViewModel } from '../../../../core/api/models';
import { ClientsApiService } from '../../../../core/api/services';
import { AlertService } from '../../../../shared/services/alert.service';

@Component({
  selector: 'app-client-feature-switch',
  templateUrl: './client-feature-switch.component.html',
  styleUrl: './client-feature-switch.component.css',
  standalone: false
})
export class ClientFeatureSwitchComponent implements OnInit {
  @Input({ required: true }) featureSwitch!: ClientFeatureSwitchViewModel;
  @Input({ required: true }) clientID!: number | undefined;

  isLoading = signal(false);

  showSettings = signal(false);
  constructor(
    private clientService: ClientsApiService,
    private alertService: AlertService
  ) {

  }

  ngOnInit(): void {
        //throw new Error('Method not implemented.');
  }

  toggleShowSettings() {
    this.showSettings.set(!this.showSettings());
  }

  settingsBtnLabel() {
    var label = "Settings";

    if (this.featureSwitch.Settings) {
      label += ` (${this.featureSwitch.Settings.filter(f => f.Active).length} of ${this.featureSwitch.Settings.length})`;
    }
    return label;

  }

  save() {
    this.isLoading.set(true);
    console.log('Saving feature switch data:', this.featureSwitch);
    var array: ClientFeatureSwitchViewModel[] = new Array(this.featureSwitch) 
    this.clientService.SaveClientFeatureSwitches({
      clientID: this.clientID ?? 0,
      body:array
    })
      .subscribe(
        {
          next: (response) => {
            console.log('Update feature switch:', response);
            this.alertService.success(`Feature Switch ${this.featureSwitch.ClientSwitchName} saved successfully`);
            this.showSettings.set(false);
            this.isLoading.set(false);
          },
          error: (error) => {
            console.error('Error updating feature switch:', error);
            this.alertService.error('Error updating feature switch - ' + error.Message);
            this.isLoading.set(false);
          }
        }
      );
  }
}
